import React, { Component } from 'react';
import SimplePopover from '../../SimplePopover';

import TabelaSimuladosAgendamento from './TabelaSimuladosAgendamento'
import { Subscribe } from 'unstated'
import UserContainer from '../../../containers/user.container'
import { PracticeTestContainer } from '../../../containers/practiceTest.container'
import CollapsablePanel from '../../CollapsablePanel';
import Filtro from './Filtro';

import Loading from '../../Loading'

class Simulado extends Component {

    isUnmounted = false

    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
            loadingGeral: false,
            exibirNotasCabecalho: false,
            filtros: {}
        };

        // this.onChangeTagsSerieAno = this.onChangeTagsSerieAno.bind(this);
        this.onClickAplicarFiltros = this.onClickAplicarFiltros.bind(this);
        this.checkSettings = this.checkSettings.bind(this)
        this.atualizarTabelaSimuladosAgendamento = this.atualizarTabelaSimuladosAgendamento.bind(this)
    }

    async componentDidMount() {
        await this.props.userContainer.getSchools()
        if(Object.keys(this.props.userContainer.state.selectedSchool).length>0 || Object.keys(this.props.userContainer.state.selectedGrade).length>0 ) {
            // console.log('set filtros');
            // console.log('filtros', this.state.filtros);
            this.setState({ filtros: { ...this.state.filtros, selectedSchool: this.props.userContainer.state.selectedSchool, selectedGrade: this.props.userContainer.state.selectedGrade.idGrade }}, () => {
                // console.log('after state filtros', this.state.filtros);

            } );
        }
    }

    componentWillUnmount() {
        this.isUnmounted = true
    }

    async checkSettings() {
        var s = await this.props.practiceTestContainer.settingsApi(this.state.filtros.escolaSelecionada.idEntitySchool, this.state.filtros.serieSelecionada);
        if (s === false) {
//            Alert.warning('Antes de agendar um simulado você deve configurar a data de início e fim dos períodos', { timeout: 'none' })
            await this.props.practiceTestContainer.setState({ fireRedirect: true });
        }
    }

    async atualizarTabelaSimuladosAgendamento(loadingTable, middleware) {
        // console.log('atualizarTabelaSimuladosAgendamento', loadingTable, middleware)
        if (this.props.userContainer.state.classes.length) {
            if (this.state.filtros.serieSelecionada) {
                if (loadingTable) this.props.practiceTestContainer.setState({ loadingTabela: true }) //Tabela

                if (middleware) await middleware()

                await this.props.practiceTestContainer.periodsApi(this.state.filtros.escolaSelecionada.idEntitySchool, this.state.filtros.serieSelecionada);
                await this.props.practiceTestContainer.agendaApi(this.state.filtros.escolaSelecionada.idEntitySchool, this.state.filtros.serieSelecionada);

                if (loadingTable) this.props.practiceTestContainer.setState({ loadingTabela: false }) //Tabela
            }
        }
    }

    async onClickAplicarFiltros(filtros) {
        this.setState({ loadingGeral: true })
        // console.log('filtros', filtros);
        //user container
        await this.props.userContainer.setState({ selectedSchool: filtros.escolaSelecionada, selectedGrade: {idGrade: filtros.serieSelecionada}, classes: [] });
        if(filtros.serieSelecionada) await this.props.userContainer.getClasses(filtros.escolaSelecionada.idEntitySchool, filtros.serieSelecionada);
        //practice container
        await this.props.practiceTestContainer.setState({ selectedSchool: filtros.escolaSelecionada, selectedGrade: {idGrade: filtros.serieSelecionada}, fireRedirect: false });

        await this.setState({ filtros: filtros }, async () => {
            if(this.state.filtros.serieSelecionada) {
                await this.atualizarTabelaSimuladosAgendamento(true, this.checkSettings);

                if (!this.props.userContainer.state.classes.length) {
                    await this.props.practiceTestContainer.setState({ periodos: [] });
                }
            }
            if (!this.isUnmounted) this.setState({ loadingGeral: false });
        });

    }

    getInfoSimuladoAtivo(ativo) {
        if (ativo) {
            return (<SimplePopover content={<div>
                <strong>Simulado</strong>
                <div>Alguns recursos estão desabilitados.</div>
            </div>}>
                <i className="fas fa-circle adap-text-green edb-margin-small-right"></i>
            </SimplePopover>)
        }
        else {
            return <></>
        }
    }

    getEmptyConfigurePeriodo() {
        return <div className="edb-container edb-margin-large-top" style={{maxWidth: '960px', margin: '0 auto'}}>
            <div className="edb-container ">
                <div className="edb-container edb-col m9">
                    <h3 className="edb-margin-none" style={{marginTop: '17px !important'}}>Não existe período para a série/ano selecionada.</h3>
                    <p>Clique no ícone de configurações (<i className="fas fa-cog"></i>) no canto da tela e programe o início e término dos períodos.</p>
                </div>
                <div className="edb-container edb-col m3"><img alt="Configure os períodos da escola" src="images/emptystates/robotGear.svg"/></div>
            </div>
        </div>
    }

    getEmptySerieSemTurmas() {
        return <div className="edb-container edb-margin-large-top" style={{maxWidth: '960px', margin: '0 auto'}}>
            <div className="edb-container edb-col m3"><img alt="Série não possui turmas" src="images/emptystates/robotAlert.svg"/></div>
            <div className="edb-container edb-rest">
                <div className="edb-row edb-margin-bottom">
                    <h3 className="edb-margin-none" style={{marginTop: '17px !important'}}>Não existem turmas para a série/ano selecionada.</h3>
                </div>
            </div>
        </div>
    }

    render() {
        const isMobile = this.state.width <= 768;
        // console.log('isMobile',isMobile)

        // console.log('this.props.userContainer.state.',this.props.userContainer.state);
        return (<div>

            <CollapsablePanel
                openText="Filtro"
                closeText="Filtro"
                isCollapsed={isMobile}
                panelContent={<Filtro isMobile={isMobile} selected={this.state.filtros} onClickAplicar={this.onClickAplicarFiltros} />}
                mainContent={<div className="edb-padding-left edb-margin-top edb-padding-top">
                    {this.state.loadingGeral && <Loading />}
                    {/******** EmptyState Lista de atividades (Selecionar filtro) ********/}
                    {!this.state.loadingGeral && !this.state.filtros.serieSelecionada && <div className="edb-padding">

                        <div className="edb-row edb-hide-small">
                            <h3 className="edb-text-bold">Agendamento dos simulados</h3>
                            <p>Utilize o <strong>filtro</strong> para selecionar uma série/ano para continuar.</p>
                        </div>
                        <div className="edb-row edb-hide-medium edb-hide-large">
                            <div className="edb-col edb-center">
                                <h3 className="edb-text-bold">Agendamento dos simulados</h3>
                                <p>Utilize o <strong>filtro</strong> para selecionar uma série/ano para continuar</p>
                            </div>
                        </div>
                    </div>}

                    {!this.state.loadingGeral && this.state.filtros.serieSelecionada && !this.props.userContainer.state.classes.length && this.getEmptySerieSemTurmas()}
                    {!this.state.loadingGeral && !this.props.practiceTestContainer.state.fireRedirect && this.state.filtros.serieSelecionada &&
                        <TabelaSimuladosAgendamento
                            isProfessor={this.props.isProfessor}
                            userContainer={this.props.userContainer}
                            practiceTestContainer={this.props.practiceTestContainer}
                            onAtualizarTabela={this.atualizarTabelaSimuladosAgendamento} />}
                    {!this.state.loadingGeral && this.props.practiceTestContainer.state.fireRedirect && this.getEmptyConfigurePeriodo()}

                </div>}
            />
        </div>);
    }
}

// higher order component
export default (props) => (<Subscribe to={[UserContainer, PracticeTestContainer]}>
    {(user, simulado) => <Simulado {...props} userContainer={user} practiceTestContainer={simulado} />}
</Subscribe>);
